import {actions} from './Reducer';

export const getCustomerArtisanFollowngList = (body) => ({
  type: actions.GET_CUSTOMER_ARTISAN_FOLLOWING_LIST,
  payload: body
})


export const getCustomerArtisanFollowingListSuccess = (followingList) => ({
  type: actions.GET_CUSTOMER_ARTISAN_FOLLOWING_LIST_SUCCESS,
  payload: followingList
})








export const removeFavArtisanPoductAction = (payload ) => ({
  type: actions.REM_CUSTOMER_ARTISAN_FOLLOWING,
  payload
})

export const removeArtisanFollownigListSuccessAction = (productID) => ({
  type: actions.REM_CUSTOMER_ARTISAN_FOLLOWING_SUCCESS,
  payload: productID
})


export const setCustomerArtisanFollownigListIsLoadingAction = (isLoading) => ({
  type: actions.SET_CUSTOMER_CUSTOMER_ARTISAN_FOLLOWING_LIST_IS_LOADING,
  payload: isLoading,
});

export const setCustomerArtisanFollownigListCountAction = (count) => ({
  type: actions.SET_CUSTOMER_CUSTOMER_ARTISAN_FOLLOWING_LIST_COUNT,
  payload: count,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_CUSTOMER_CUSTOMER_ARTISAN_FOLLOWING_SEARCH_VALUE,
  payload: value,
});